import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import Api from "api/Api";

const api = new Api();

const initialState = {
  id: "",
  displayName: "",
  login: "",
  email: "",
  lang: "en-US",
  companies: [],
  status: "idle",
  error: null,
};

export const fetchUser = createAsyncThunk(
  "user/fetchUser",
  async () => {
    const response = await api.getUserInfo();
    return response;
  }
);

export const fetchUserProfile = createAsyncThunk(
  "user/fetchUserProfile",
  async () => {
    const response = await api.getUserProfile();
    return response;
  }
);

export const updateUserLanguage = createAsyncThunk(
  "user/updateUserLanguage",
  async (languageData) => {
    const response = await api.updateUserLanguage(languageData);
    return response;
  }
);

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    resetUser: () => {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchUser.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.displayName = action.payload.displayName;
        state.companies = action.payload.companies || [];
        // Legacy fields
        state.id = action.payload.id;
        state.login = action.payload.login;
        state.lang = action.payload.language || "en-US";
      })
      .addCase(fetchUserProfile.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchUserProfile.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.id = action.payload.id;
        state.login = action.payload.login;
        state.email = action.payload.email;
        state.lang = action.payload.language || "en-US";
      })
      .addCase(fetchUserProfile.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(updateUserLanguage.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(updateUserLanguage.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.id = action.payload.id;
        state.login = action.payload.login;
        state.email = action.payload.email;
        state.lang = action.payload.language || "en-US";
      })
      .addCase(updateUserLanguage.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { resetUser } = userSlice.actions;

export default userSlice.reducer;

export const selectUserInfo = (state) => state.user;
export const selectUserCompanies = (state) => state.user.companies;
